import { Box, Stack } from "@mui/material";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { ReactElement } from "react";

interface SectionProps {
  title?: string;
  content: ReactElement | null;
  textAlign?: string;
  noDivider?: boolean;
  centerTitle?: boolean;
  subtitle?: ReactElement;
  is100?: boolean;
  leftAligned?: boolean;
  mobileHorizontalMargin?: number;
}

function Section({
  title,
  content,
  textAlign = "start",
  noDivider,
  centerTitle = true,
  subtitle,
  is100,
  leftAligned,
  mobileHorizontalMargin = 2,
}: SectionProps) {
  const primaryColor = is100 ? "#8A4319" : "#C46A2D";

  return (
    <Stack
      sx={{
        flexGrow: 1,
        mx: { xs: mobileHorizontalMargin, sm: 3, md: 4, lg: 5 },
      }}
    >
      {title ? (
        <Typography
          mt={{ xs: 1, sm: 2 }}
          sx={
            centerTitle && !leftAligned
              ? { textAlign: "center" }
              : { ml: { xs: mobileHorizontalMargin, sm: 3, md: 6, lg: 8 } }
          }
          fontSize={{ xs: 22, sm: 26, md: 28, lg: 30 }}
          color={primaryColor}
          fontFamily="Source Sans Pro SemiBold"
        >
          {title}
        </Typography>
      ) : null}
      {subtitle ? (
          <Box
          ml={{ xs: mobileHorizontalMargin, sm: 3, md: 6, lg: 8 }}
          color="#62605A"
        >
          {subtitle}
        </Box>
      ) : null}
      <Box
        sx={{
          mt: { xs: 1, sm: 2 },
          mb: noDivider ? { xs: 1, sm: 2 } : { xs: 3, sm: 4, md: 5 },
        }}
      />
      <Container
        sx={{
          textAlign: textAlign,
          color: "#62605A",
          fontSize: { xs: "12px", sm: "14px", md: "16px" }, // Responsive font size for content
        }}
      >
        {content}
      </Container>
      <br />
    </Stack>
  );
}

export default Section;
